import { computed, inject, Injectable, linkedSignal, signal } from '@angular/core';
import { Apollo } from 'apollo-angular';

export type UserState = {
  kassenzeichen: string;
  kassenzeichenValidated?: boolean;
  zaehlernummer: string;
  zaehlernummerValidated?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class UserStateService {

  public userStateSignal = signal<UserState>({
    kassenzeichen: '',
    kassenzeichenValidated: false,
    zaehlernummer: '',
    zaehlernummerValidated: false,
  });



  public isKassenzeichenValid = computed(() => {
    console.debug('Checking if kassenzeichen is valid:', this.userStateSignal().kassenzeichen);
    return this.userStateSignal().kassenzeichen.length > 0 && this.userStateSignal().kassenzeichenValidated === true;
  });

  public isZaehlernummerValid = computed(() => {
    console.debug('Checking if zaehlernummer is valid:', this.userStateSignal().zaehlernummer);
    return this.userStateSignal().zaehlernummer.length > 0 && this.userStateSignal().zaehlernummerValidated === true;
  });

  public isLoggedIn = computed(() => {
    return this.isKassenzeichenValid();
  });



  async resetUserState() {
    this.userStateSignal.set({
      kassenzeichen: '',
      kassenzeichenValidated: false,
      zaehlernummer: '',
      zaehlernummerValidated: false,
    });
  }




  get kassenzeichen() {
    return this.userStateSignal().kassenzeichen;
  }

  get zaehlernummer() {
    return this.userStateSignal().zaehlernummer;
  }

  get kassenzeichenValidated() {
    return this.userStateSignal().kassenzeichenValidated;
  }

  get zaehlernummerValidated() {
    return this.userStateSignal().zaehlernummerValidated;
  }




  saveUserStateToLocalStorage() {
    const userState = this.userStateSignal();
    localStorage.setItem('userState', JSON.stringify(userState));
  }

  loadUserStateFromLocalStorage() {
    const userStateString = localStorage.getItem('userState');
    if (userStateString) {
      const userState: UserState = JSON.parse(userStateString);
      this.userStateSignal.set(userState);
    }
  }
}
